export const deactivateLabel = 'Deactivating is basically deleting, without actually deleting.';
export const reActivate = 're-activate';
export const deActivate = 'de-activate';
export const bioPlaceholder = 'Technician bio...';
export const bioLabel = 'Technician Bio';
export const phoneNumberPlaceholder = 'Technician phone number...';
export const phoneNumberLabel = 'Technician Phone Number';
export const emailPlaceholder = 'Technician email...';
export const emailLabel = 'Technician Email';
export const namePlaceholder = 'Technician name...';
export const nameLabel = 'Technician Name';
export const viewPortalAsTechnician = 'View Portal as Technician';
export const updateUserSuccess = (message) => `Successfully updated technician: ${message}!`;
export const errorUpdatingUser = (message) => `Error updating technician: ${message}`;
